module.exports = __webpack_public_path__ + "static/media/logo_via_plus_sidebar.837cb991.png";